import { render, staticRenderFns } from "./auto-transfer.vue?vue&type=template&id=1a5e6fd8&"
import script from "./auto-transfer.vue?vue&type=script&lang=js&"
export * from "./auto-transfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports